import React, { useEffect } from 'react'
import { NavLink } from 'react-router-dom'
import { useThirdPartyLogin } from 'hooks/useThirdParyLogin'
import { PhantomIconNewIcon, MetaMaskIconNewIcon } from 'components/ui-kit/Icons/svg/index'
import { useQuery } from 'hooks/useQuery'
import { loginWithTwitch } from 'redux-thunk/thunk/auth.thunk'
import { useDispatch, useSelector } from 'react-redux'
import { getAuthToken } from 'helpers/cookie.helpers'
import WalletStatusPopup from '../../../../games/PredictionMarket/components/WalletStatusPopup/index'

const SocialLinks = (props) => {
  const { isBannerSection, isLoginSignup } = props
  const dispatch = useDispatch()
  const {
    t,
    checkEthereum,
    requestPhantomAccount,
    redirectToHome,
    walletStatus,
    closeWalletStatus
  } = useThirdPartyLogin()
  const { isPwaInstalled } = useSelector(state => state.settings)
  const query = useQuery()
  const code = query.get('code')

  useEffect(() => {
    if (code && !getAuthToken()) {
      dispatch(loginWithTwitch({ code, redirectToHome }))
    }
  }, [code])

  const handleRetry = () => {
    closeWalletStatus()
    if (walletStatus.wallet === 'metamask') checkEthereum()
    if (walletStatus.wallet === 'phantom') requestPhantomAccount()
  }

  const walletPopup = walletStatus && (
    <WalletStatusPopup
      wallet={walletStatus.wallet}
      status={walletStatus.status}
      onClose={closeWalletStatus}
      onRetry={handleRetry}
    />
  )

  if (isBannerSection) {
    return (
      <div className='auth-social-listing-wrap'>
        <div className='auth-social-heading'>
          <h6><span>{t('orContinueWith')}</span></h6>
        </div>
        <div className='auth-social-ul d-flex align-items-center'>
          {!isPwaInstalled &&
            <>
              <div className='auth-social-card flex-grow-1'>
                <NavLink to='#' onClick={checkEthereum} className='auth-social-icon flex items-center justify-center'>
                  <MetaMaskIconNewIcon className='!h-5 !w-auto !max-h-[20px] !max-w-[22px] mx-auto' />
                </NavLink>
              </div>
              <div className='auth-social-card flex-grow-1'>
                <NavLink to='#' onClick={requestPhantomAccount} className='auth-social-icon flex items-center justify-center'>
                  <PhantomIconNewIcon className='!h-5 !w-auto !max-h-[20px] !max-w-[22px] mx-auto' />
                </NavLink>
              </div>
            </>}
        </div>
        {walletPopup}
      </div>
    )
  }

  if (isLoginSignup) {
    return (
      <div className='flex justify-center auth-social-ul auth-social-listing-wrap d-flex justify-content-center login-social-icons'>
        {!isPwaInstalled &&
          <>
            <div className='auth-social-card flex-grow-1'>
              <NavLink to='#' onClick={checkEthereum} className='auth-social-icon w-100 flex items-center justify-center'>
                <MetaMaskIconNewIcon className='!h-6 !w-6 mx-auto' />
              </NavLink>
            </div>
            <div className='auth-social-card flex-grow-1'>
              <NavLink to='#' onClick={requestPhantomAccount} className='auth-social-icon w-100 flex items-center justify-center'>
                <PhantomIconNewIcon className='!h-6 !w-6 mx-auto' />
              </NavLink>
            </div>
          </>}
        {walletPopup}
      </div>
    )
  }
}

export default SocialLinks